/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Audio_Description_Export_Status_Mixing_Audio_ProgressInputs */



/**
* | output |
* | --- |
* | "Mixing audio... {timecode}" |
*
* @param {Audio_Description_Export_Status_Mixing_Audio_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_mixing_audio_progress = /** @type {((inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Mixing_Audio_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Mixage audio... ${i?.timecode}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audiomischung... ${i?.timecode}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Mixaggio audio... ${i?.timecode}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сведение звука... ${i?.timecode}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Mezclando audio... ${i?.timecode}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`音频混合中... ${i?.timecode}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`オーディオをミキシングしています... ${i?.timecode}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो मिक्सिंग... ${i?.timecode}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Mixagem de áudio... ${i?.timecode}`)
	return /** @type {LocalizedString} */ (`Mixing audio... ${i?.timecode}`)
});